import Vue from "vue";
import Router from "vue-router";
import {getHomeModulesRouter} from "./modules/Home";
import * as Cookies from "js-cookie";
import store from "@/store";
import decodeTicket from "@/utils/decodeTicket";
import {login,logout} from "@/utils/utils";
import configR from '@/configs.js';
// 获取用户的导航与角色权限
import getRoleAndNavigation from '@/utils/getRoleAndNavigation'
// 路由配置
export default (async function (){
  let Home = await getHomeModulesRouter();
  let systemStatusSetting =  store.getters.systemStatusSetting;
  decodeTicket();

  const originalReplace = Router.prototype.push
  Router.prototype.push = function push(location) {
    return originalReplace.call(this, location).catch(err => err)
  }
  Vue.use(Router);
  console.log('Home----', Home)

  const router = new Router({
    // mode: "history",
    routes: [
      // 首页
      Home,
      {
        path: "/AccessDenied",
        name: "AccessDenied",
        components: { default: () => import('@/views/Error/AccessDenied') },
        meta: { title: '无权限' },
      },
      {
        path: "/SystemUpdating",
        name: "SystemUpdating",
        components: { default: () => import('@/views/Error/SystemUpdating') },
        meta: { title: '系统升级中' },
      },
      {
        path: "/Error",
        name: "Error",
        components: { default: () => import('@/views/Error/Error') },
        meta: { title: '哎呀，出错了！' },
      },
      // 404
      {
        path: '*',
        name: 'NotFound',
        components: { default: () => import('@/views/Error/404') },
        meta: { title: '未找到页面' },
      },
    ],
    scrollBehavior(to, from, savePosition) {
      if (savePosition) {
        return savePosition;
      }
      return null
    },
  });

// 路由守卫
  router.beforeEach(async(to, from, next) => {
    let isLogin = Cookies.get("isLogin");

    if(!isLogin) {
      // 游客
      if (configR.envConfigs.VUE_APP_DIRECT_LOGIN === 'true') {
        // 直接登陆
        await  store.dispatch('signOut')
        login();
        return false;
      }else{
        if(to.name === 'Tourist') {
          next();
          return false
        }
        if(to.name === 'Index' || to.name === 'Teacher' || to.name === 'Student' || to.name === 'Visitor') {
          next({ name: "Tourist" });
        }

      }
    }
    if(to.name === 'AccessDenied') {
      next();
      return false
    }
// 获取当前系统状态
    let systemStatus = store.getters.systemStatus;
    if(systemStatus && systemStatusSetting.includes(to.name)) {
      next();
      return false
    }
    if(systemStatus && systemStatusSetting.includes(systemStatus)) {
      next({ name: systemStatus });
      return false;
    }

    let userWhiteNavs = store.getters.userWhiteNavs;
    let userAuthedWhiteNavs = store.getters.userAuthedWhiteNavs;

    let AccessDenied =  "AccessDenied";
    if (to.path === "/") {
      let homeRouter = '';
      if(userAuthedWhiteNavs.length === 0) {
        homeRouter =  AccessDenied
      } else {
        homeRouter = userAuthedWhiteNavs[0];
       // homeRouter = homeRouter === 'Home' ? 'Index' : homeRouter;
      }
      next({ name: homeRouter });
    }else{
      if(to.name === AccessDenied) {
        next()
        return false;
      }
      if(userWhiteNavs.indexOf(to.name) > -1) {
        next();
      }else {
        next({ name: AccessDenied });
      }
    }
  });
  return  router
}())

